import { createContext } from 'use-context-selector';
import { TransactionsProviderState } from './types';
import { defaultTransactionsProviderState } from './defaultState';

const TransactionsContext = createContext<TransactionsProviderState>(defaultTransactionsProviderState);

export { TransactionsContext };
